import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { EMPTY_ARRAY_LENGTH } from '../constants/constants';

export function validateNoEmptyField(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value == null || typeof control.value !== 'string') {
            return { emptyField: true };
        }

        const trimmedControlValue = control.value.trim();
        if (trimmedControlValue.length === EMPTY_ARRAY_LENGTH) {
            return { emptyField: true };
        }

        return null;
    };
}

export function validateNoSquareBrackets(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (typeof control.value === 'string' && /[[\]]/.test(control.value)) {
            return { squareBrackets: true };
        }
        return null;
    };
}
